import React from "react";

import Box from "components/common/Box";

/**
 * Figma footer — full-bleed images:
 * - Mobile / responsive (xs): /images/dashboard/footer-mobile.png
 * - Desktop (md+): /images/dashboard/footer.png
 */
const footerImgSx = {
  width: "100%",
  display: "block",
  mt: { xs: 2, md: 3 },
};

const AllInOneFooter = ({ mobileMarginBottom = 0 }) => (
  <>
    <Box
      component="img"
      src="/images/dashboard/footer-mobile.png"
      alt="India's AI Investing Platform"
      sx={{
        ...footerImgSx,
        display: { xs: "block", md: "none" },
        mb: { xs: mobileMarginBottom, md: 0 },
      }}
    />
    <Box
      component="img"
      src="/images/dashboard/footer.png"
      alt="India's AI Investing Platform"
      sx={{
        ...footerImgSx,
        display: { xs: "none", md: "block" },
      }}
    />
  </>
);

export default AllInOneFooter;
